<template>
    <div class="delete-confirmation">
        <div class="delete-confirmation__card">
            <i class="delete-confirmation__close-button material-icons" @click="close">
                close
            </i>

            <form class="delete-form">
                <p class="delete-form__question">
                    Are you sure about deleting {{ userId }}?
                </p>

                <input class="delete-form__input"
                       type="password"
                       placeholder="password"
                       v-model="password"
                >

                <button class="train-select__delete"
                        @click.prevent="deleteUser">
                    del
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: ''
        }
    },
    computed: {
        userId() {
            return this.$store.getters['user/userToDel'];
        }
    },
    methods: {
        deleteUser() {
            this.$store.dispatch('user/delUser', this.password);
        },
        close() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped lang="scss">
.delete-confirmation{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 900;
}

.delete-confirmation__card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $color-white;
    @include default-shadow;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;

    @include medium {
        width: 31rem;
    }

    @include extra-large {
        width: 44rem;
    }
}

.delete-confirmation__close-button{
    position: absolute;
    top:0;
    right:0;
    cursor: pointer;
    font-size: 2.5rem;
}

.delete-form{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 1.25rem;
    margin-right: 2.5rem;
}

.delete-form__input{
    font-size: 1.25rem;

    @include extra-large {
        font-size: 2rem;
    }
}

.delete-form__question{
    font-size: 1rem;

    @include medium {
        font-size: 1.25rem;
    }

    @include extra-large {
        font-size: 1.5rem;
    }
}

.train-select__delete {
    @include extra-large {
        font-size: 2.5rem;
        min-height: 4rem;
    }
}
</style>
